import { ProgressBar, SizeClassName } from "react-migration/components/ProgressBar";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

type UsageRowProps = {
  title: string;
  children: React.ReactNode;
  progressBarColor?: "bg-positive-500" | "bg-platform-600";
  used: number;
  cap: number;
  resetDate: string;
  unlimitedMessage?: string;
  isUnlimited: boolean;
};

export const UsageRow = ({
  title,
  children,
  progressBarColor = "bg-positive-500",
  used,
  cap,
  resetDate,
  unlimitedMessage,
  isUnlimited,
}: UsageRowProps) => {
  const { t } = useTranslation();
  const left = cap - used;
  return (
    <>
      <p className="mb-2 text-lg font-semibold text-neutral-800">{title}</p>
      {isUnlimited && unlimitedMessage && (
        <p className="text-base font-semibold text-md text-neutral-600">{unlimitedMessage}</p>
      )}
      {!isUnlimited && (
        <>
          <div className="flex items-center gap-2 mb-1">
            <div className="grow max-w-[600px]">
              <ProgressBar
                rounded
                className={progressBarColor}
                size={SizeClassName.MLARGE}
                percentage={(100 * left) / cap}
              />
            </div>
            <div className="text-neutral-600">
              {t("dashboard.credit_summary.x_of_x_remaining", {
                left,
                cap,
              })}
            </div>
          </div>
          {resetDate && (
            <p className="text-sm text-neutral-600">
              {t("dashboard.credit_summary.resets_on_date", {
                date: resetDate,
              })}
            </p>
          )}
        </>
      )}
      <p className="mb-6 text-base text-md text-neutral-600">{children}</p>
    </>
  );
};
